import type { RouterOptions } from 'owa-router';
import { initializeMailRoutes, getCurrentRoute } from 'owa-mail-routing';

export const mailRouterOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentRoute),
    vdir: window?.location?.pathname.indexOf('/hosted/mail') == 0 ? 'hosted/mail' : 'mail',
    defaultRoute: '/',
    registerRoutes: initializeMailRoutes,
};
